import { render, staticRenderFns } from "./BannerContainer.vue?vue&type=template&id=297be245"
import script from "./BannerContainer.vue?vue&type=script&lang=js"
export * from "./BannerContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports